import { useAppSelector } from './'
import { TGlobalState } from '../types';

export const useAuth = () => {
  const authData = useAppSelector((state: TGlobalState) => state.auth)
  const isAuth = useAppSelector((state: TGlobalState) => !!state.auth.token)

  return { authData, isAuth }
}
